import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const AIChatSection = () => {
    // Use state to handle chat triggering from the homepage
    const triggerChat = () => {
        // We can dispatch a custom event that the ChatWidget will listen to,
        // or simulate a click on the floating chat button.
        const chatBtn = document.querySelector('.chat-toggle-btn');
        if (chatBtn) chatBtn.click();
    };

    return (
        <section className="ai-chat-section py-5 my-5 p-4 rounded-5 mx-3 mx-lg-5 overflow-hidden position-relative align-items-center d-flex">
            <div className="ai-chat-bg"></div>

            <div className="container position-relative z-1 py-5">
                <div className="row align-items-center justify-content-center">
                    <div className="col-12 col-lg-7 text-center text-lg-start mb-5 mb-lg-0 text-white">
                        <span className="badge bg-white text-dark mb-3 px-3 py-2 rounded-pill fw-bold text-uppercase d-inline-flex align-items-center">
                            <i className="fa-solid fa-sparkles text-brand-green me-2"></i> Nuevo
                        </span>
                        <h2 className="display-4 fw-black mb-4 lh-sm text-shadow">
                            Hablá con nuestro Asistente Inteligente
                        </h2>
                        <p className="fs-5 mb-4 opacity-75 text-shadow-sm w-lg-75">
                            Consultá sobre talles, envíos, métodos de pago o pedí recomendaciones personalizadas. Nuestro AI está disponible 24/7 para ayudarte en tu compra resolviendo tus dudas al instante.
                        </p>

                        <button
                            onClick={triggerChat}
                            className="btn btn-brand-green btn-lg rounded-pill px-5 py-3 fw-bold ai-chat-cta shadow-lg"
                        >
                            <i className="fa-solid fa-comment-dots me-2"></i> Consultar Ahora
                        </button>
                    </div>

                    <div className="col-12 col-lg-5 d-none d-lg-block text-center position-relative">
                        <div className="chat-illustration d-inline-block position-relative">
                            <i className="fa-brands fa-reddit-alien floating-robot"></i>
                            <div className="chat-bubble-1">¡Hola! ¿En qué puedo ayudarte?</div>
                            <div className="chat-bubble-2">Quería saber sobre las remeras...</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AIChatSection;
